import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useAuth } from 'util/auth'

export default function LogoutPage() {
  const auth = useAuth()
  const router = useRouter()
  useEffect(() => {
    const logout = async () => {
      await auth.signout()
      router.push('/')
    }
    logout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}
